var render = function render(){var _vm=this,_c=_vm._self._c;return _c('agent-sessions-list',{class:{ 'gl-mt-5': !_vm.isLoading && _vm.allSessions.length > 0 },attrs:{"sessions":_vm.allSessions,"is-loading":_vm.isLoading}})
}
var staticRenderFns = []

export { render, staticRenderFns }